import deepmerge from 'deepmerge';

import { BANK_CODES } from '@js/constants/banks';
import { reduce } from '@/components/Form/javascripts/codes';

import fieldName, { groupName, CLONE_IDENTIFIER, CLONE_REGEXP } from '../javascripts/name';
import { destroy } from '../javascripts/identified';

function next(name) {
  const [prefix, index] = name.split(CLONE_IDENTIFIER);

  return [prefix, (parseInt(index, 10) || 0) + 1].join(CLONE_IDENTIFIER);
}

export default function cloner(props, planter) {
  const {
    schema,
    branches,
  } = planter;

  function cloning(sch, identifier, key) {
    const { fields } = sch[key];
    const index = fields.length - 1;
    const leaves = fields[index];
    const values = Object.values(leaves);

    const { group } = values[0];

    values.forEach((field) => {
      field.group = groupName(CLONE_REGEXP.test(group)
        ? next(group)
        : next(fieldName(identifier, key)));
    });

    if (!leaves._destroy) {
      leaves._destroy = destroy(sch, identifier || `${key}[${index}]`, key);
    }

    leaves._destroy.rules = reduce(BANK_CODES, [
      [{ rule: 'required' }],
    ]);
  }

  function clone(sch, identifier, key, clones = 1) {
    if (typeof sch === 'string') {
      const _breadcrumb = sch
        .split(CLONE_IDENTIFIER)
        .shift()
        .split('[')
        .map((i) => i.replace(']', ''))
        .flatMap((i) => [i, 'fields'])
        .slice(0, -1);

      clone(
        _breadcrumb
          .slice(0, -1)
          .reduce((reduced, reducing) => reduced[reducing], schema.value),
        fieldName(..._breadcrumb.filter((_, i) => !(i % 2)).slice(0, -1)),
        _breadcrumb.slice(-1).pop(),
        clones,
      );

      return;
    }

    for (let i = 0; i < clones; i += 1) {
      const last = sch[key].fields[sch[key].fields.length - 1];

      sch[key].fields.push(deepmerge(last, {}));
      cloning(sch, identifier, key);
    }
  }

  function clonable(branch) {
    if (!CLONE_REGEXP.test(branch)) {
      return false;
    }

    const _next = next(branch);

    if (Object.values(branches.value).some((i) => i === _next)) {
      return false;
    }

    return props.clones[branch.split(CLONE_IDENTIFIER).shift().toLowerCase()];
  }

  return {
    cloning,
    clonable,
    clone,
  };
}
